import React from 'react';
import { ItemList } from './ItemList';

const MainContent = () => {
  return (<ItemList />);
};

export { MainContent };
